import React from "react";

import Hero from "../../presentational/Hero";

export default function HeroContainer(props) {
  return (
    <Hero fluid link="testimonials">
      <h1>Testimonials</h1>
    </Hero>
  );
}



/** WEBPACK FOOTER **
 ** ./src/components/containers/Testimonials/HeroContainer.jsx
 **/